var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import highlightjs from 'highlight.js';
import javascript from 'highlight.js/lib/languages/javascript';
import xml from 'highlight.js/lib/languages/xml';
import BareHighlight from 'react-fast-highlight/lib/js/BareHighlight';
import styles from './codeHighlight.module.scss';
highlightjs.registerLanguage('javascript', javascript);
highlightjs.registerLanguage('xml', xml);
/**
 * A component that parses a string and returns tokenized and colored HTML from
 * programming language configurations. Eg. JavaScript.
 */
export const CodeHighlight = (_a) => {
    var { children, languages, className } = _a, rest = __rest(_a, ["children", "languages", "className"]);
    return (_jsx("div", Object.assign({ className: classNames({
            [styles.root]: true,
        }, className) }, rest, { children: _jsx(BareHighlight, Object.assign({ highlightjs: highlightjs, languages: languages }, { children: children })) })));
};
